__turbopack_context__.v({
  "blurBackground": "UpgradeDialogLayout-module__crLAYq__blurBackground",
  "closeButtonContainer": "UpgradeDialogLayout-module__crLAYq__closeButtonContainer",
  "column": "UpgradeDialogLayout-module__crLAYq__column",
  "container": "UpgradeDialogLayout-module__crLAYq__container",
  "ctaContainer": "UpgradeDialogLayout-module__crLAYq__ctaContainer",
  "headerContainer": "UpgradeDialogLayout-module__crLAYq__headerContainer",
  "imageColumn": "UpgradeDialogLayout-module__crLAYq__imageColumn",
  "planImage": "UpgradeDialogLayout-module__crLAYq__planImage",
  "row": "UpgradeDialogLayout-module__crLAYq__row",
  "title": "UpgradeDialogLayout-module__crLAYq__title",
});
